/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_News_TitleInputs */

const en_us2_community_news_title = /** @type {(inputs: Community_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's new`)
};

const pt_br2_community_news_title = /** @type {(inputs: Community_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novidades`)
};

const es_419_community_news_title = /** @type {(inputs: Community_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novedades`)
};

const pt_pt2_community_news_title = /** @type {(inputs: Community_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novidades`)
};

const fr_fr2_community_news_title = /** @type {(inputs: Community_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveautés`)
};

const de_de2_community_news_title = /** @type {(inputs: Community_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuigkeiten`)
};

const it_it2_community_news_title = /** @type {(inputs: Community_News_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novità`)
};

/**
* | output |
* | --- |
* | "What's new" |
*
* @param {Community_News_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_news_title = /** @type {((inputs?: Community_News_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_News_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_news_title(inputs)
	if (locale === "es-419") return es_419_community_news_title(inputs)
	if (locale === "pt-PT") return pt_pt2_community_news_title(inputs)
	if (locale === "fr-FR") return fr_fr2_community_news_title(inputs)
	if (locale === "de-DE") return de_de2_community_news_title(inputs)
	if (locale === "it-IT") return it_it2_community_news_title(inputs)
	return en_us2_community_news_title(inputs)
});
export { community_news_title as "community.news_title" }